import {
    GET_CASE_DETAILS_SUCCESS,
    GET_CASE_DETAILS_FAILURE,
    EDIT_CASE_DETAILS_SUCCESS,
    EDIT_CASE_DETAILS_FAILURE,
    GET_CASE_DETAILS_REQUEST,
    CANCEL_CASE_SUCCESS,
    CANCEL_CASE_FAILURE,
    GET_AVAILABLE_UNITS_REQUEST,
    GET_AVAILABLE_UNITS_SUCCESS,
    GET_AVAILABLE_UNITS_FAILURE, EDIT_CASE_DETAILS_REQUEST
} from './constants';

const initialState = {
    caseList: [],
    caseFaller: undefined,
    edited: undefined,
    editFailer: undefined,
    loading: false,
    cancelCase: false,
    availableUnits: undefined,
    dateOfReturn: undefined,
    myUnits: undefined,
    getCasesSuccess: undefined,
    editingDataLoading: false,
    success: null,
    isFetching: false,
};

const caseDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CASE_DETAILS_REQUEST: {
            return Object.assign({}, state, {
                loading: false,
                getCasesSuccess: undefined,
                cancelCase: false,
                caseFaller: false,
                edited: undefined,
                availableUnits: undefined,
                dateOfReturn: undefined,
                myUnits: undefined,
                isFetching: false
            });
        }
        case GET_CASE_DETAILS_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                getCasesSuccess: true,
                cancelCase: false,
                caseFaller: false,
                edited: undefined,
                caseList: action.data,
                availableUnits: undefined,
                dateOfReturn: undefined,
                myUnits: undefined,
                isFetching: false
            });
        }
        case GET_CASE_DETAILS_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                getCasesSuccess: false,
                cancelCase: false,
                caseFaller: true,
                edited: undefined,
                availableUnits: undefined,
                dateOfReturn: undefined,
                myUnits: undefined,
                isFetching: false
            });
        }
        case EDIT_CASE_DETAILS_REQUEST: {
            return Object.assign({}, state, {
                loading: false,
                editingDataLoading: true,
                getCasesSuccess: undefined,
                cancelCase: false,
                caseFaller: false,
                edited: undefined,
                editFailer: false,
                availableUnits: undefined,
                dateOfReturn: undefined,
                myUnits: undefined,
                success: null,
                isFetching: false
            });
        }
        case EDIT_CASE_DETAILS_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                editingDataLoading: false,
                getCasesSuccess: undefined,
                cancelCase: false,
                caseFaller: false,
                edited: true,
                editFailer: false,
                caseList: action.data,
                availableUnits: undefined,
                dateOfReturn: undefined,
                myUnits: undefined,
                success: true,
                isFetching: false
            });
        }
        case EDIT_CASE_DETAILS_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                editingDataLoading: false,
                getCasesSuccess: undefined,
                cancelCase: false,
                caseFaller: false,
                edited: false,
                editFailer: true,
                availableUnits: undefined,
                dateOfReturn: undefined,
                myUnits: undefined,
                isFetching: false
            });
        }
        case CANCEL_CASE_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                getCasesSuccess: undefined,
                cancelCase: true,
                caseFaller: false,
                edited: undefined,
                availableUnits: undefined,
                dateOfReturn: undefined,
                myUnits: undefined,
                isFetching: false
            });
        }
        case CANCEL_CASE_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                getCasesSuccess: undefined,
                cancelCase: false,
                caseFaller: false,
                edited: undefined,
                availableUnits: undefined,
                dateOfReturn: undefined,
                myUnits: undefined,
                isFetching: false
            });
        }
        case GET_AVAILABLE_UNITS_REQUEST: {
            return Object.assign({}, state, {
                loading: false,
                getCasesSuccess: undefined,
                cancelCase: false,
                caseFaller: false,
                edited: undefined,
                availableUnits: undefined,
                dateOfReturn: undefined,
                myUnits: undefined,
                isFetching: true
            });
        }
        case GET_AVAILABLE_UNITS_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                getCasesSuccess: undefined,
                cancelCase: false,
                caseFaller: false,
                edited: undefined,
                availableUnits: action.data.availableUnits,
                dateOfReturn: action.data.date,
                myUnits: action.data.myUnits,
                isFetching: false
            });
        }
        case GET_AVAILABLE_UNITS_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                getCasesSuccess: undefined,
                cancelCase: false,
                caseFaller: false,
                edited: undefined,
                availableUnits: undefined,
                dateOfReturn: undefined,
                myUnits: undefined,
                isFetching: false
            });
        }
        default: {
            return state;
        }
    }
};

export default caseDetailsReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/CaseDetails/reducer.js